// Purpose: full-viewport grid pattern, one of three atmospheric layers
// on the sign-in page. 60x60 cells, 0.5px stroke, opacity + stroke
// driven by CSS vars so theme flip re-colors it without React state.
//
// The mockup uses this at z-index 0 behind the hero content. Consumer
// places it inside a parent with position:relative; it fills that
// parent.
//
// Opacity + stroke values live on the `.opacity-grid` / `.stroke-grid`
// classes (styles.css) so the rendered DOM carries no `style="..."`
// attribute (Commit 8b.8 dropped style-src `'unsafe-inline'`). The
// `strokeVar` + `opacityVar` props that previously allowed per-instance
// overrides were unused by callers (Login, ExternalShell both call
// <GridPattern /> with no overrides) and were removed with the
// inline-style refactor.

export interface GridPatternProps {
  className?: string;
}

export function GridPattern({ className }: GridPatternProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      aria-hidden
      className={['absolute inset-0 pointer-events-none opacity-grid', className ?? ''].join(' ')}
    >
      <defs>
        <pattern id="ast-grid" width="60" height="60" patternUnits="userSpaceOnUse">
          <path d="M 60 0 L 0 0 0 60" fill="none" className="stroke-grid" strokeWidth="0.5" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#ast-grid)" />
    </svg>
  );
}
